import { graphql } from '../graphql/graphql';

export const buttonFragment = graphql(`
  fragment Button on Button {
    __typename
    text
    buttonVariant
    ariaLabel
    iconName
    iconPlacement
    sizeVariant
    buttonType
    trackingEvent
  }
`);
